module.exports = __webpack_public_path__ + "7b8015b72e9ee1dc545b0cd2b1b70c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_descriptions_show_2x.png
// module id = 119
// module chunks = 0 1 2 3 4